module.exports = __webpack_public_path__ + "static/media/0.086216f2.png";